import {
  type AuthErrorOperation, type AuthErrorResolution, authErrorTelemetry, resolveAuthError
} from '../auth/authErrorPolicy';
import {track} from './analytics';

export type AuthFailureEventName = | 'evenplay_auth_failed' | 'evenplay_camera_failed' | 'evenplay_kyc_logout_failed'
  | 'evenplay_otp_request_failed' | 'fullswing_deferred_join_failed' | 'fullswing_login_failed'
  | 'legacy_fullswing_session_join_failed';

/**
 * Reports an auth failure using only the policy-approved dimensions. The raw
 * error is classified in memory and is never passed to console or analytics.
 */
export const reportAuthFailure = (eventName: AuthFailureEventName, error: unknown, operation: AuthErrorOperation): AuthErrorResolution => {
  const resolution = resolveAuthError(error, operation);
  const telemetry = authErrorTelemetry(resolution);

  console.warn(`[Auth] ${eventName}`, telemetry);

  try {
    track(eventName, telemetry);

  } catch {
    console.error('[Auth] telemetry reporting failed', {eventName, ...telemetry});
  }

  return resolution;
};
